export default __webpack_public_path__ + "static/media/723.8d6d20f9.png";